/**
 * AdminRoute — route gate for Bloq-team-only pages.
 *
 * `useAuth().user.is_admin` is set on the user row in MongoDB (seeded for
 * `founder@bloq.video`). Anyone without it gets bounced to /app/meetings
 * with a one-line toast. This intentionally hides the destination from
 * non-admins entirely — no "Permission denied" page, no flash of admin UI.
 *
 * Keep this dead simple: no role lists, no permission checks beyond the
 * single `is_admin` boolean. When we add more Bloq-staff roles (support,
 * billing) they can layer on top of this same primitive.
 */
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) return <Navigate to="/app/meetings" replace />;
  return children;
}
